import { NotificationFilters } from '../../domain/interface/notification';
import { NotificationType } from 'modules/core/domain/interfaces/supabase/notifications/types';
import React from 'react';
import Select from 'modules/organizers/ui/elements/select';
import { sortOptions, typeOptions } from 'modules/notifications/domain/const';

type Props = {
  filters: NotificationFilters;
  onChange: (filters: NotificationFilters) => void;
  className?: string;
};

const NotificationsFilters: React.FC<Props> = ({ filters, onChange, className }) => {
  return (
    <div className={`flex items-center gap-4 ${className || ''}`}>
      <Select
        headerText="Тип уведомления"
        options={typeOptions}
        value={typeOptions.find((o) => o.value === (filters.type || 'all'))}
        onChange={(opt) => onChange({ ...filters, type: opt?.value as NotificationType | 'all' })}
        style={{ minWidth: 200 }}
      />
      <Select
        headerText="Сортировка"
        options={sortOptions}
        value={sortOptions.find((o) => o.value === (filters.sort || 'desc'))}
        onChange={(opt) => onChange({ ...filters, sort: opt?.value as 'desc' | 'asc' })}
        style={{ minWidth: 120 }}
      />
    </div>
  );
};

export default NotificationsFilters;
